/* tslint:disable */
/* eslint-disable */
export enum CalculationTypeEnum {
  Custom = 'custom',
  CustomShape = 'custom-shape',
  OneSlope = 'one-slope',
  TwoSlopes = 'two-slopes',
  FourSlopes = 'four-slopes',
  FenceSlat = 'fence-slat',
  FencePanel = 'fence-panel',
}
